import { FC } from 'react'
import { RawAdvisorReview } from 'components/features/coaching/advisor/types/advisor'
import styles from 'components/features/coaching/advisor/AdvisorReview/AdvisorReview.styl'
import { StarsRow } from 'components/features/coaching/advisorPublicPage/StarsRow/StarsRow'
import moment from 'moment'
import { ReadMore } from 'components/atoms/ReadMore/ReadMore'
import QuoteSvg from 'icons/quote.svg'
import SvgIcon from 'components/atoms/SvgIcon'

type AdvisorReviewProps = {
  review: RawAdvisorReview
}
export const AdvisorReview: FC<AdvisorReviewProps> = (props) => {
  const { review } = props
  const { rating, author } = review
  const { short_name, city_full_name } = author
  return (
    <div className={ styles.advisorReview }>
      <div className={ styles.header }>
        <div className={ styles.quotes }>
          <SvgIcon src={ QuoteSvg } />
        </div>
        <div className={ styles.date }>{ moment(review.created).format('MMM D, YYYY') }</div>
      </div>
      <div className={ styles.text }>
        <ReadMore text={ review.text } wideLimit={ 180 } narrowLimit={ 70 } />
      </div>
      <div className={ styles.stars }>
        <StarsRow rating={ rating } />
      </div>
      <div className={ styles.name }>
        { short_name }
      </div>
      { city_full_name && (
        <div className={ styles.location }>
          from { city_full_name }
        </div>
      )}
    </div>
  )
}
